import { RootState, SessionState } from '../types'

export const SESSION_CACHE_KEY = 'session'
export const SET = 'session//SET'

type SessionPayload = Partial<SessionState['data']>

interface SetSessionAction {
  type: typeof SET
  payload: SessionPayload
}

type SessionActions = SetSessionAction

export function setSession(data: SessionPayload): SetSessionAction {
  if (data?.token) {
    sessionStorage.setItem(SESSION_CACHE_KEY, JSON.stringify({ data }))
  }
  return {
    type: SET,
    payload: data,
  }
}

export function getSession(store: RootState): SessionState['data'] {
  return store.session.data
}

export const getSessionInitialState = (): SessionState => {
  const isNew = window.location.search.includes('id=')
  if (isNew) {
    sessionStorage.removeItem(SESSION_CACHE_KEY)
  }
  const sessionJSON = sessionStorage.getItem(SESSION_CACHE_KEY)
  return isNew || !sessionJSON
    ? {
        data: {
          id: '',
          token: '',
          pin: '',
          completed: false,
        },
      }
    : (JSON.parse(sessionJSON) as SessionState)
}

// eslint-disable-next-line func-names
export default function sessionReducer(
  state: SessionState | undefined,
  action: SessionActions
): SessionState {
  const currentState = state || getSessionInitialState()
  switch (action.type) {
    case SET:
      return {
        ...currentState,
        data: {
          ...currentState.data,
          ...action.payload,
        },
      }

    default:
      return currentState
  }
}
